import { render } from "./HoodieOrderDetails.vue?vue&type=template&id=177ac1f3"
import script from "./HoodieOrderDetails.vue?vue&type=script&lang=ts"
export * from "./HoodieOrderDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script